import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightCircleIcon } from 'lucide-react';
import type { OfferItem } from '../types/offer';
type OfferCardProps = {
  item: OfferItem;
  index: number;
};
export function OfferCard({
  item,
  index
}: OfferCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 22
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.45,
    delay: Math.min(index * 0.06, 0.3)
  }} className="flex flex-col rounded-2xl border border-white/10 bg-ink-800/80 p-6 transition-colors hover:border-brand-cyan/35 sm:p-8" data-id="element-98" data-mp="mi3ohrldyc3t">
      <div className="mx-auto w-full max-w-[300px] overflow-hidden rounded-xl bg-ink-900" data-id="element-99" data-mp="1aeht6xqwtdrr">
        <img src={item.image} alt={item.title} loading="lazy" className="h-full w-full object-cover" data-id="element-100" data-mp="15g6f2atl0h3q" />
      </div>

      <div className="mt-6 text-center" data-id="element-101" data-mp="1y53pjrrjx9lx">
        {item.badge ? <p className="mb-1 text-sm font-extrabold uppercase tracking-wide text-brand-red" data-id="element-102" data-mp="1y3slrry3w1ut">
            {item.badge}
          </p> : null}
        <h3 className="text-lg font-extrabold leading-snug text-white" data-id="element-103" data-mp="ddunlcwdzv6e">
          {item.title}{' '}
          {item.highlight ? <span className="text-brand-red" data-id="element-104" data-mp="3vsdp3tdwv77x">{item.highlight}</span> : null}
        </h3>
      </div>

      <p className="mt-4 rounded-lg bg-brand-red px-4 py-2.5 text-center text-[13px] font-bold leading-snug text-white" data-id="element-105" data-mp="3njk1rgm7o01">
        {item.promise}
      </p>

      <ul className="mt-5 flex-1 space-y-3.5" data-id="element-106" data-mp="3qtiy445siccq">
        {item.bullets.map(bullet => <li key={bullet} className="flex gap-3 text-sm leading-relaxed text-white/65" data-id="element-107" data-mp="3cu14nbhjuax1">
            <ArrowRightCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" aria-hidden="true" data-id="element-108" data-mp="3cwdqhzqfh5fd" />
            <span data-id="element-109" data-mp="1b3potutfmq1p">{bullet}</span>
          </li>)}
      </ul>

      <p className="mt-6 border-t border-white/10 pt-4 text-center text-xs font-semibold uppercase tracking-[0.18em] text-white/40" data-id="element-110" data-mp="1f3zq4u6a4sa8">
        Valor real: <span className="text-white/70" data-id="element-111" data-mp="2o2rho04peuc4">{item.value}</span>
      </p>
    </motion.article>;
}